require("../scss/styles.scss");
import Cookies from 'js-cookie'

import $ from "jquery";
window.$ = $;

import Selectize from "./selectize_clear.js";
import slick from "slick-carousel";

function init()
{
    $(".slider").slick({
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });

    function activatePanel(panel)
    {
        const $panel = $("#"+panel);
        $(".topic").not($panel).hide();
        $panel.fadeIn();
    }

    $(".section_nav a").click(function (e) {
        e.preventDefault();
        const panel = $(this).data("href");
        activatePanel(panel);
        $(".section_nav li").not($(this).parent()).removeClass("active");
        $(this).parent().addClass("active");
    });
    $(".menubutton").click(function () {
        $("body").toggleClass("body--showmenu");
    });

    $("#filtermenu select").change(function () {
        this.form.submit();
    });

    $("#filtermenu select").each(function () {
        if ($(this).attr("name")=="Number" ||
            $(this).attr("name")=="Sort"  ||
            $(this).attr("name")=="Status" ||
            $(this).attr("name")=="IsPublic") {
            $(this).selectize({
            });
        } else {
            $(this).selectize({
                plugins: {
                    'clear_selection': {}
                },
            });
        }
    });

    $(".section_nav_select").change(function () {
        activatePanel(this.value);
    }).selectize();

    $('#filtermenu [type="checkbox"]').change(function () {
        this.form.submit();
    });
    $("#selectall").change(function () {
        if (this.checked) {
            $(".item_select input").prop('checked', true);
        } else {
            $(".item_select input").prop('checked', false);
        }
    });
    $(".deletelink").click(function (e) {
        if (!confirm("Sind Sie sicher?")) {
            e.preventDefault();
        }
    });

    //Editing

    $("#Form_EditForm_Image").change(function (event) {
        $("#Form_EditForm_Image_Preview").attr(
            "src",
            URL.createObjectURL(event.target.files[0])
        );
        $("#Form_EditForm_Image_Name").html(event.target.files[0].name);
    });

    $("#Form_EditForm_Image2").change(function (event) {
        $("#Form_EditForm_Image2_Preview").attr(
            "src",
            URL.createObjectURL(event.target.files[0])
        );
        $("#Form_EditForm_Image2_Name").html(event.target.files[0].name);
    });

    $("#addtolist").change(function () {
        $(this.form).append('<input type="hidden" name="format" value="addtolist"/>');
        this.form.target="_self";
        this.form.submit();
    }).each(function () {
        $(this).selectize();
    });

    $("#removefromlist").click(function () {
        this.form.target="_self";
    });

    const activateMaps = function () {
        $('[data-behaviour="map"]').each(function () {
            const $map = $(this);
            $map.addClass("map_container--active")
            $("iframe", $map).attr("src", $map.data("src"));
        });
        Cookies.set('maps-activated', '1', { expires: 365, path: '/' });
    }

    $('[data-behaviour="map"]').each(function () {
        const $map = $(this);
        $(".button", $map).click(function () {
            activateMaps();
        })
    });

    if(Cookies.get('maps-activated')) {
        activateMaps();
    }
}

$(init);
